import { FilterOptionLicense } from 'src/models/FilterMetric';

const isQueriableSubagent = (
  filterLicenseSelected: FilterOptionLicense,
  loggedUserRole: string,
): boolean => {
  if (loggedUserRole === 'AGE') {
    return false;
  }
  return (
    filterLicenseSelected.queryKey !== '' &&
    filterLicenseSelected.queryKey !== 'default' &&
    filterLicenseSelected.queryKey.split(',').length === 1
  );
};

export default isQueriableSubagent;
